<clr-alert [clrAlertType]="'success'" (clrAlertClosedChange)="onClose()">
  <clr-alert-item>
    <span class="alert-text">
      {{ message }}
    </span>
  </clr-alert-item>
</clr-alert>
